import { SvgProsperfull } from '@assets/svgr/Prosperfull'
import { NavButton } from '@components/Elements/Button'
import { Pressable } from '@components/Elements/Pressable'
import { Text } from '@components/Elements/Text'
import { ScreenLayout } from '@components/Layouts'
import { appVersion } from '@lib/constants'
import { useI18n } from '@lib/i18n'
import { openExternalLink } from '@lib/linking'
import { TrackingEvent, trackEvent } from '@lib/tracking'
import { useNavigation } from '@react-navigation/native'
import { useAppStore } from '@stores/app'
import { useToastsStore } from '@stores/toasts'
import { Colors } from '@vetahealth/fishing-gear/colors'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import styled, { useTheme } from 'styled-components/native'
import { RouteName } from '../../../routeNames'

const ContentWrapper = styled.View`
  padding: 20px 0;
`
const ScrollView = styled.ScrollView.attrs({
  contentContainerStyle: {
    flexGrow: 1,
    justifyContent: 'space-between',
  },
})``
const ImageWrapper = styled.View`
  margin: 10px 0;
`
const InfoWrapper = styled.View`
  margin: 20px 20px 0;
`
const Info = styled(Text).attrs({
  size: 'tiny',
  isCentered: true,
})``
const Wrapper = styled.View`
  margin: 20px 0 10px;
  padding: 0 20px;
  gap: 5px;
`

export function AboutList() {
  const t = useI18n()
  const theme = useTheme()
  const navigation = useNavigation()
  const [addToast] = useToastsStore((state) => [state.addToast])
  const [isDevMode, setDevMode] = useAppStore((state) => [state.isDevMode, state.setDevMode])
  const [devCount, setDevCount] = useState(0)

  function handleTermsOfServicePress(): void {
    trackEvent(TrackingEvent.aboutTermsOfServicePressed)
    openExternalLink(t('links.termsOfService'))
  }

  function handlePrivacyPolicyPress(): void {
    trackEvent(TrackingEvent.aboutPrivacyPolicyPressed)
    openExternalLink(t('links.privacyPolicy'))
  }

  function handleDevMode() {
    setDevCount((prev) => prev + 1)
  }

  useEffect(() => {
    if (devCount >= 5) {
      addToast({ message: isDevMode ? 'Dev Mode disabled' : 'Dev Mode enabled' })
      setDevMode()
      setDevCount(0)
    }
  }, [devCount])

  return (
    <ScreenLayout title={t('screen.about')} hasBack isStatic>
      <ScrollView>
        <ContentWrapper>
          <ImageWrapper>
            <SvgProsperfull fill={theme.colors.primary} width="100%" height={34} />
          </ImageWrapper>
          <Wrapper>
            <NavButton
              color={Colors.ink600}
              icon={['fad', 'memo-circle-check']}
              label={t('about.termsOfService')}
              onPress={handleTermsOfServicePress}
            />
            <NavButton
              color={Colors.azure500}
              icon={['fad', 'shield-check']}
              label={t('about.privacyPolicy')}
              onPress={handlePrivacyPolicyPress}
            />
            <NavButton
              color={Colors.mint400}
              icon={['fad', 'brackets-curly']}
              label={t('about.licenses')}
              onPress={() => navigation.navigate(RouteName.Licenses)}
            />
          </Wrapper>
          <Pressable
            onPress={handleDevMode}
            render={() => (
              <InfoWrapper>
                <Info color={isDevMode ? Colors.green500 : theme.colors.secondaryText}>
                  {t('about.version', { version: appVersion })}
                </Info>
                <Info i18n-ignore color={theme.colors.secondaryText}>
                  {' '}
                  © {dayjs().get('year')} Veta Health Inc.
                </Info>
              </InfoWrapper>
            )}
          />
        </ContentWrapper>
      </ScrollView>
    </ScreenLayout>
  )
}
